module.exports = __webpack_public_path__ + "img/1-3.20b1370f.png";